import type { PaintingAsset } from '@/types'

/*
 * Fixed references to the paintings in storage, used by the hand-written pages
 * (hero, biography, technique). The gallery itself reads from the artworks collection.
 */
export const PAINTINGS_CDN = 'https://rembrandt-light-and-shadow.cdn.modulify.website/paintings'

export const PAINTINGS = {
    selfPortrait: {
        slug: 'self-portrait-1659',
        src: `${PAINTINGS_CDN}/self-portrait-1659.jpg`,
        width: 3202,
        height: 4096,
        title: 'Self-Portrait',
        year: '1659',
        alt: 'Rembrandt in his fifties, wearing a dark beret and a brown coat, looking directly out at the viewer.'
    },
    philemonAndBaucis: {
        slug: 'philemon-and-baucis',
        src: `${PAINTINGS_CDN}/philemon-and-baucis.jpg`,
        width: 4096,
        height: 3183,
        title: 'Philemon and Baucis',
        year: '1658',
        alt: 'A dim, lamp-lit cottage interior where an elderly couple approach a table at which a bearded god in a golden robe and a young man sit.'
    },
    lucretia: {
        slug: 'lucretia',
        src: `${PAINTINGS_CDN}/lucretia.jpg`,
        width: 3486,
        height: 4096,
        title: 'Lucretia',
        year: '1664',
        alt: 'A young woman in a golden gown and pearl necklace holding a dagger, her head tilted in sorrow.'
    },
    circumcision: {
        slug: 'the-circumcision',
        src: `${PAINTINGS_CDN}/circumcision.jpg`,
        width: 4096,
        height: 3068,
        title: 'The Circumcision',
        year: '1661',
        alt: 'A kneeling priest in a glowing white robe bends over the infant Christ held by Mary in a dark stable.'
    },
    gentlemanWithTallHat: {
        slug: 'portrait-of-a-gentleman-with-a-tall-hat-and-gloves',
        src: `${PAINTINGS_CDN}/gentleman-with-tall-hat.jpg`,
        width: 3443,
        height: 4096,
        title: 'Portrait of a Gentleman with a Tall Hat and Gloves',
        year: 'c. 1656/1658',
        alt: 'A man in a tall black hat and black suit with a white lace collar, holding a pair of gloves.'
    },
    polishNobleman: {
        slug: 'a-polish-nobleman',
        src: `${PAINTINGS_CDN}/polish-nobleman.jpg`,
        width: 2801,
        height: 4096,
        title: 'A Polish Nobleman',
        year: '1637',
        alt: 'A mustached man in a tall fur hat and fur-trimmed robe, hung with gold chains and holding a gilded staff.'
    },
    youngManSeated: {
        slug: 'a-young-man-seated-at-a-table',
        src: `${PAINTINGS_CDN}/young-man-seated-at-a-table.jpg`,
        width: 3313,
        height: 4096,
        title: 'A Young Man Seated at a Table (possibly Govaert Flinck)',
        year: 'c. 1660',
        alt: 'A young man with long wavy hair in black clothes and a white collar, seated beside a tall black hat.'
    },
    ladyWithFan: {
        slug: 'portrait-of-a-lady-with-an-ostrich-feather-fan',
        src: `${PAINTINGS_CDN}/lady-with-ostrich-feather-fan.jpg`,
        width: 3368,
        height: 4096,
        title: 'Portrait of a Lady with an Ostrich-Feather Fan',
        year: 'c. 1656/1658',
        alt: 'A woman in a black dress and wide white collar holding a large white ostrich feather.'
    },
    apostlePaul: {
        slug: 'the-apostle-paul',
        src: `${PAINTINGS_CDN}/apostle-paul.jpg`,
        width: 3267,
        height: 4096,
        title: 'The Apostle Paul',
        year: 'c. 1657',
        alt: 'A bearded old man at a desk resting his head in one hand and holding a quill in the other, a sword beside him.'
    },
    oldLadyWithBook: {
        slug: 'an-old-lady-with-a-book',
        src: `${PAINTINGS_CDN}/old-lady-with-a-book.jpg`,
        width: 3404,
        height: 4096,
        title: 'An Old Lady with a Book',
        year: '1637',
        alt: 'An elderly woman in a black cap and wide white ruff, seated with spectacles in one hand and a book in her lap.'
    }
} satisfies Record<string, PaintingAsset>
